export default {
  metadata: {
    version: '1.0.0',
    id: 'date-picker-year-view-1.0.0',
    name: 'JDSDatepickerYearView'
  },
  hierarchy: {
    container: ['jds_datepicker_view_button']
  },
  base: {
    container: {
      'flex-direction': '{d_0}',
      height: 300,
      width: '{d_1}',
      'align-items': '{d_2}',
      overflow: 'scroll'
    }
  },
  variant: {},
  combination: [{}],
  combination_config: [[]],
  api: {
    data: {
      container: {
        value: {
          type: 'list',
          name: 'loadedYears',
          object: {
            name: 'string',
            selected: 'boolean',
            disabled: 'boolean'
          }
        }
      },
      jds_datepicker_view_button: {
        name: {
          type: 'string',
          name: 'loadedYears.name'
        },
        selected: {
          type: 'boolean',
          name: 'loadedYears.selected'
        },
        disabled: {
          type: 'boolean',
          name: 'loadedYears.disabled'
        }
      }
    },
    events: {
      container: {
        onScroll: {
          name: 'onScroll',
          platform: 'web'
        }
      },
      jds_datepicker_view_button: {
        onSelect: 'onSelect'
      }
    },
    a11y: {
      container: {
        properties: {
          role: {
            value: 'list'
          }
        }
      }
    }
  }
};
